<template>
  <div class="min-h-screen flex flex-col items-center justify-center text-center px-4">
    <p class="text-6xl font-extrabold text-brand-600">404</p>
    <p class="mt-3 text-ink-soft">This page doesn't exist.</p>
    <router-link :to="{ name: 'Dashboard' }" class="btn btn-primary mt-6">
      Back to dashboard
    </router-link>
  </div>
</template>

<script>
export default { name: 'NotFound' }
</script>
